import { MoovDefinitionCustomerAdoptionDTO as MoovDefinitionCustomerAdoptionDTO } from "../DTO/moovDefinitionCustomerAdoptionDTO";

export class MoovDefinitionCustomerAdoption{
    public id!:number;
    public customerId!:number;
    public moovDefinitionId!:number;
    public usageTypeOverride?:number; //see MoovDefinition for possible values
    public usagePriceOverride?:number;
    public billingBucketIdOverride?:number;

    constructor(){}

    public static mapFromDTO(param:MoovDefinitionCustomerAdoptionDTO):MoovDefinitionCustomerAdoption{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovDefinitionCustomerAdoption();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.moovDefinitionId = param.moovDefinitionId;
            obj.usageTypeOverride = param.usageTypeOverride;
            obj.usagePriceOverride = param.usagePriceOverride;
            obj.billingBucketIdOverride = param.billingBucketIdOverride;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovDefinitionCustomerAdoption):MoovDefinitionCustomerAdoptionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovDefinitionCustomerAdoptionDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.usageTypeOverride = param.usageTypeOverride;
            dto.usagePriceOverride = param.usagePriceOverride;
            dto.billingBucketIdOverride = param.billingBucketIdOverride;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}